export function Divider({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-3">
      <div className="flex-1 h-px" style={{ background: "#E8E6E3" }} />
      <span
        className="text-[10px] font-medium uppercase tracking-wider"
        style={{ color: "#9E9A94" }}
      >
        {label}
      </span>
      <div className="flex-1 h-px" style={{ background: "#E8E6E3" }} />
    </div>
  );
}
